
<div  style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex">
        <div class="h6 font-weight-bold sm-22 pt-1">
            <!-- <i class="fas fa-redo pr-2 pl-0 primary-text"></i> -->
            <svg class="mr-2" width="20" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2C1.5 1.17157 2.17157 0.5 3 0.5H13C13.8284 0.5 14.5 1.17157 14.5 2V14C14.5 14.8284 13.8284 15.5 13 15.5H3C2.17157 15.5 1.5 14.8284 1.5 14V2Z" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99977 8.79546C9.51303 8.79546 10.7398 7.56872 10.7398 6.05546C10.7398 4.5422 9.51303 3.31546 7.99977 3.31546C6.48651 3.31546 5.25977 4.5422 5.25977 6.05546C5.25977 7.56872 6.48651 8.79546 7.99977 8.79546Z" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.5 12.6847C11.62 11.0148 9.88758 9.96957 8 9.96957C6.11242 9.96957 4.38004 11.0148 3.5 12.6847" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Profile
        </div>
    </div>
    <div class="row m-0">
        <div class="col-md-6 head-top">
            <div *ngIf="!auth.user.email_verified_at" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
                <div class="d-flex justify-content-between align-items-center p-3">
                    <div class="gilroy-bold pt-1 sm-10 color-blue">
                        <img src="assets/images/key.png" alt="Verification" class="mr-1" width="16px">
                        Verification
                    </div>
                    <div class="lightGrey-text sm-10">
                       <!--  {{auth.user.email_verified_at | date}} -->
                    </div>
                </div>
                <div class="d-flex justify-content-between p-3 align-items-center">
                    <div class="sm-12 color-blue gilroy-bold mobile16">Your Email pending verification</div>
                    <div>
                        <button  class="btn primary-btn px-3 btn-widthFull sm-12" (click)="resendEmail()">Resend Email</button>
                    </div>
                </div>
                </div>
                <div *ngIf="auth.user.email_verified_at" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
                    <div class="d-flex justify-content-between align-items-center p-3">
                        <div class="gilroy-bold pt-1 sm-10 color-green">
                            <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="16px">
                            <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                            Verification
                        </div>
                        <div class="text-secondary sm-10">
                            <!-- {{auth.user.email_verified_at | date}} -->
                            {{ common.carbonToJs(auth.user.email_verified_at) }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between p-3">
                        <div class="sm-12 color-green gilroy-bold mobile16">Your email is Verified</div>
                    </div>
                </div>
                <div *ngIf="auth.user.email_verified_at && !auth.user.verified" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
                    <div class="d-flex justify-content-between align-items-center p-3">
                        <div class="gilroy-bold pt-1 sm-10 color-blue">
                            <img src="assets/images/key.png" alt="Verification" class="mr-1" width="16px">
                            Verification
                        </div>
                        <div class="lightGrey-text sm-10">
                           <!--  {{auth.user.email_verified_at | date}} -->
                        </div>
                    </div>
                    <div class="d-flex justify-content-between p-3 align-items-center">
                        <div class="sm-12 color-blue gilroy-bold mobile16">Your Account is pending verification</div>
                        <!-- <div>
                            <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/account">Verify Account</button>
                        </div> -->
                    </div>
                </div>
                <div *ngIf="auth.user.email_verified_at && auth.user.verified" class="card border-0 verified-box d-flex align-items-between radius-5 py-2 my-2 mx-0">
                    <div class="d-flex justify-content-between align-items-center p-3">
                        <div class="gilroy-bold pt-1 sm-10 color-green">
                            <img src="assets/images/key_green.PNG"  alt="Verification" class="mr-1" width="24px">
                            <!-- <i class="fa fa-money p-0 sm-16 mr-1"></i> -->
                           Verification
                        </div>
                        <div class="lightGrey-text sm-10">
                           <!--  {{auth.user.email_verified_at | date}} -->
                        </div>
                    </div>
                    <div class="d-flex justify-content-between p-3 align-items-center">
                        <div class="sm-12 color-green gilroy-bold mobile16">Your Account is verified</div>
                        <div>
                            <button  class="btn primary-btn px-3 btn-widthFull sm-12" routerLink="/send-money">Send money</button>
                        </div>
                    </div>
                </div>
            <div class="p-1">
                <div class="row pl-3 mt-3">
                    <div class="d-flex"> 
                        <h5 class="profile-name sm-18 font-weight-bold">Your name</h5>
                        <span class="verified-Or-Not sm-10">verified</span>
                    </div>
                </div>
                <div class="row">
                    <p class="sm-12 pl-3 pt-2 mobile16">{{auth.user.name}}</p>
                </div>
            </div>
<!--             <div class="row pl-3 mt-3">
                <div class="d-flex">
                    <h5 class="profile-name sm-18 font-weight-bold pt-3 ">Your address</h5>
                    <span class="verified-Or-Not sm-10 mt-3">verified</span>
                </div>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">13 haminton</p>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">st louis</p>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">Missouri</p>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">USA</p>
            </div>
            <div class="row pl-3 mt-3">
                <div class="d-flex"> 
                    <h5 class="profile-name sm-18 font-weight-bold pt-3">Your identity documents</h5>
                    <span class="verified-Or-Not sm-10 mt-3">verified</span>
                </div>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">USA</p>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">USA</p>
            </div>
            <div class="row">
                <p class="sm-12 pl-3 mb-1">USA</p>
            </div> -->
            
            
            
        </div>
    </div>
</div>